module.exports = __webpack_public_path__ + "img/image5.adfdeed0.png";